import { FormInstance } from "antd";

import { TrialContentUploadVideoType } from "../types";

export default function setValuesOnEdit(
  record: TrialContentUploadVideoType,
  form: FormInstance<any>
) {
  const {
    id,
    videoTitle,
    productCategoryId,
    introVideoFileName,
    videoFileName,
    videoThumbnail,
    videoThumbnailUrl,
  } = record;

  const videoThumbnailFileList = videoThumbnail
    ? [
        {
          uid: "0",
          name: videoThumbnail,
          status: "done",
          url: videoThumbnailUrl,
          thumbUrl: videoThumbnailUrl,
        },
      ]
    : null;

  console.log("hello", introVideoFileName, videoFileName);

  form.setFieldsValue({
    id,
    videoTitle,
    productCategoryId,
    introVideoFile: introVideoFileName,
    videoFile: videoFileName,
    videoThumbnailFile: videoThumbnailFileList,
  });
}
